import BaseTypography from "@mui/material/Typography";
import type { TypographyProps } from "@mui/material/Typography";

export const Typography = (props: TypographyProps) => (
	<BaseTypography {...props} />
);
